import React, {Component, useState, useEffect, Fragment } from 'react';
import { Message } from "element-react";
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
// import './detail.scss';
import $ from 'jquery';
import classNames from 'classnames';
import API from '../../../config/api';
import {Toast} from 'antd-mobile';
import tools from '@/utils/tool';
import audioPlayIcon from '@/assets/audio_play_icon.png'
import audioPauseIcon from '@/assets/audio_pause_icon.png'
import audioSliderCircleIcon from '@/assets/slider_circle_icon.png'
import { Slider, WingBlank, WhiteSpace } from 'antd-mobile';
const DETAIL_TYPE = {
  PICTEXT: 'PICTEXT', // 图文
  VIDEO: 'VIDEO', // 视频
  SWIPER: 'SWIPER' // 图说
}
class Detailtext extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uuid: '',
      data: {},
      playSpeedAry:['1','1.25','1.5','2'], // 播放速度
      curSelectSpeed:'', // 当前选择的倍数
      audioPlayStatus:false,
      audioDuration:'', // 音频总时长
      audioCurTime:0,
    }
  }
  componentWillMount() {
    const data = this.props.data;
    let _this = this;
    this.setState({
      data,
    },() => {
      if(data.audio && data.audio.length > 0){
        let audioEle = this.refs.audioDom
        audioEle.addEventListener("loadedmetadata", function () {
          //加载数据
          //音频的总长度
          _this.setState({
            audioDuration: data.audio[0].duration,
          });
        });
        audioEle.addEventListener(
          "timeupdate",
          function () {
            var curAudioCurTime = audioEle.currentTime;
            _this.setState({
              audioCurTime:curAudioCurTime || 0
            });
          },
          false
        );
        audioEle.addEventListener('ended',function(){
          _this.setState({
            audioPlayStatus:false
          })
        })
      }
      this.allaudio()
      this.replaceHref()
      document.title = data.title;
    })
  }

  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    // const newData = nextProps.data;
    // if (newData && newData !== this.state.data) {
    //   this.setState({
    //     data: newData,
    //   }, () => {
    //     if(newData.audio && newData.audio.length > 0){
    //       let audioEle = this.refs.audioDom
    //       if(audioEle) {
    //         audioEle.addEventListener("loadedmetadata", function () {
    //           this.setState({
    //             audioDuration: newData.audio[0].duration,
    //           });
    //         }.bind(this));
    //       }
    //     }
    //     this.allaudio()
    //     this.replaceHref()
    //     document.title = newData.title;
    //   })
    // }
  }
  componentWillUnmount() {}
  // 将富文本中的a标签链接替换为当前环境的链接
  replaceHref() {
    for (var i = 0; i < $('a').length; i++) {
      var href = $($('a')[i]).attr('href')
      if (href && href.indexOf('type=') > -1 && href.indexOf('uuid=') > -1) {
        var array = href.split('&');
        var obj = {};
        for (var j = 0; j < array.length; j++) {
          var arr = array[j].split('=');
          obj[arr[0]] = arr[1]
        }
        var new_href = API.host + '/index.html#/';
        switch (obj.type) {
          case 'article': // 文章
            new_href += 'detail/1/' + obj.uuid;
            break;
          case 'video': // 视频
            new_href += 'detail/2/' + obj.uuid + '/2';
            break;
          case 'live': // 直播
            new_href += 'detail/2/' + obj.uuid + '/6';
            break;
          case 'imageSays': // 图说
            new_href += 'detail/3/' + obj.uuid;
            break;
          case 'normalSpecial': // 常规专题
            new_href += 'subject/1/' + obj.uuid;
            break;
          case 'timeLineSpecial': // 时间线专题
            new_href += 'subject/2/' + obj.uuid;
            break;
          case 'newSpecial': // 新型专题
            new_href += 'newSubject' + obj.uuid;
            break;
        }
        $($('a')[i]).attr('href', new_href)
      }
    }
  }
  allaudio() {
    var _this = this;
    var audios = $('audio');
    function pauseAll() {
        var self = this;
        [].forEach.call(audios, function (i) {
            i !== self && i.pause();
            if(i.id === "namet" && !!i.paused){
              _this.setState({
                audioPlayStatus:false
              })
            }
        })
    }
    [].forEach.call(audios, function (i) {
        i.addEventListener("play",function(){
          if(i.id === "namet" && i.paused){
            _this.setState({
              audioPlayStatus: true
            })
          }
            pauseAll.bind(i)()
        }.bind(i));
    })
  }

  // 切换音频播放倍数
  changeSpeed = (speed) => {
    this.setState({
      curSelectSpeed:speed
    })
    let audioEle = this.refs.audioDom
    if(audioEle) audioEle.playbackRate = speed;
  }

  // 切换音频播放、暂停
  togglePlayStatus = () => {
    this.setState({
      audioPlayStatus:!this.state.audioPlayStatus
    },() => {
      let audioEle = this.refs.audioDom
      if(!audioEle) return
      if(this.state.audioPlayStatus){
        audioEle.play()
      } else {
        audioEle.pause()
      }
    })
  }

  // 改变音频滑块
  changeAudioSlider = (value) => {
    this.setState({
      audioCurTime:value
    },() => {
      let audioEle = this.refs.audioDom
      if(audioEle) audioEle.currentTime = value
    })
  }
  // 替换富文本中的单位
  replacRem(content) {
    for (var i = 10; i < 50; i++) {
      var px = i + 'px';
      var rem = i / 100 * 2 + 'rem'
      content = content.replace(new RegExp(px, 'g'), rem)
    }
    return content
  }
  render() {
    const {data, audioDuration, audioCurTime, audioPlayStatus, playSpeedAry, curSelectSpeed} = this.state;
    return (
      data && data.content ? <Fragment>
        <div style={{color:'#hsl(16.34deg 88.89% 50.59%)',fontSize:'14px', backgroundColor:'hsl(60deg 100% 50.2%)', padding:'10px 0px', textAlign:'center'}}>内部使用，请勿外传</div>
        <div className="picText-box">
          {/*题目*/}
          <div className="title" style={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            'WebkitLineClamp': '2',
            'WebkitBoxOrient': 'vertical',
          }}>{data.title}
          </div>

          {/*其他信息*/}
          <div className="info-box">
            <div className="left">
              <div>{data.head_author}</div>
            </div>
            <div className="right">
              <div className="publish_time">{data.publish_time}</div>
            </div>
          </div>
          {/* 音频 */}
          {data.audio && data.audio.length > 0 ?
            <div className="audioWrapper">
              <audio ref='audioDom' src={data.audio[0].url} id="namet"></audio>
              <div className="audioModule">
                <div className="leftControl">
                  <div className="timeline">
                    <div className="curTime">{tools.secondToMS(audioCurTime)}</div>
                    <div className="sliderModule">
                      <Slider
                        value={audioCurTime / 1}
                        min={0}
                        max={audioDuration / 1}
                        step={1}
                        handleStyle={{
                          height: '12px',
                          width: '12px',
                          backgroundImage: `url(${audioSliderCircleIcon})`,
                          backgroundSize: '100% 100%',
                        }}
                        onChange={this.changeAudioSlider.bind(this)}
                      />
                    </div>
                    <div className="duration">{tools.secondToMS(audioDuration)}</div>
                  </div>
                  <div className="playSpeed">
                    播放倍数：
                    {playSpeedAry.map((item, index) => {
                      return <span className={`${item === curSelectSpeed ? 'isActive' : ''} speedItem`}
                        key={index}
                        onClick={this.changeSpeed.bind(this, item)}>{`x${item}`}</span>
                    })}
                  </div>
                </div>
                <div className="playPause">
                  {!audioPlayStatus ?
                    <img src={audioPlayIcon} alt="" onClick={this.togglePlayStatus} />
                    :
                    <img src={audioPauseIcon} alt="" onClick={this.togglePlayStatus} />
                  }
                </div>
              </div>
            </div>
            : ''}
          {/*概述*/}
          {data && data.desc ?
            <div key={Date.now()} className="desc" dangerouslySetInnerHTML={{ __html: data.desc }}></div> : ''}

          {/*正文*/}
          {data && data.content ?
            <div className="main-text"
              dangerouslySetInnerHTML={{ __html: this.replacRem(data.content) }}></div>
            : ''}
        </div>
      </Fragment> :
      <div style={{height:'100vh', display:'flex', justifyContent:'center', alignItems:'center', backgroundColor:'#f5f5f5', fontSize:'16px'}}>内容不存在</div>
    )
  }
}
export default Detailtext



// WEBPACK FOOTER //
// ./src/pages/Preview/Detail/detail.js